import React from 'react';
import { IProps, IState } from './types';
import _ from 'lodash';
// import moment from 'moment';
import moment from 'moment-timezone';
import service from 'bff/services/promotionListService';
import { Activity } from 'bff/models/info';
import { PromotionContent } from 'bff/models/promotion';
import { RouterSettings } from 'constants/models/routerSettings';
import PromotionTypeDefines from 'constants/models/promotionTypeDefines';
import { PromotionType, PromotionSectionType } from 'constants/enums/promotionType.enum';
import { storageKeys } from 'constants/enums/storageKeys.enum';
import commonService from 'utils/commonService';
import storageService from 'utils/storageService';
import SliderAdvanced from 'components/SliderAdvanced';
import SliderMobile from 'components/SliderMobile';
import CardGrid from 'components/Card/CardGrid';

class PromotionsList extends React.Component<IProps, IState> {
  private promotionsListRef = React.createRef() as React.RefObject<HTMLDivElement>;
  private sectionPromotionRef = React.createRef() as React.RefObject<HTMLDivElement>;
  private sectionPrizeWinnerRef = React.createRef() as React.RefObject<HTMLDivElement>;
  private sectionValueAddRef = React.createRef() as React.RefObject<HTMLDivElement>;

  readonly state: IState = {
    activeTab: PromotionType.All,
    tabFixed: false,
    promotionSection: {
      [PromotionSectionType.Promotion]: {
        ref: this.sectionPromotionRef,
        route: RouterSettings.Promotions.InnerPage,
        loadedMore: false,
        initDataAmount: 3
      },
      [PromotionSectionType.PrizeWinner]: {
        ref: this.sectionPrizeWinnerRef,
        route: RouterSettings.Promotions.Announcement,
        loadedMore: false,
        initDataAmount: 3
      },
      [PromotionSectionType.ValueAdd]: {
        ref: this.sectionValueAddRef,
        route: RouterSettings.Promotions.Service,
        loadedMore: false,
        initDataAmount: 3
      }
    },
    promotionList: {
      PROMOTION: [],
      PRIZE_WINNER: [],
      VALUE_ADD: []
    },
    activities: {
      MORE_ACTIVITY_URL: '',
      ACTIVITY: []
    }
  }

  async componentDidMount () {
    const initSetting = await service.fetchInitSetting();
    this.setState(state => ({
      ...state,
      promotionList: { ...initSetting.promotionList },
      activities: { ...initSetting.activities }
    }));
    // console.log(this.state);
  }

  componentDidUpdate () {
    // this.addWindowScrollEvent();

    if (storageService.getItem(storageKeys.TempInfo)) {
      this.handleSetTempState();
    }
  }

  componentWillUnmount () {
    // this.removeWindowScrollEvent();

    // 取得各 Section「載入更多」的狀態 (State)
    const promotionSectionLoadedMore = {} as any;
    Object.keys(this.state.promotionSection).forEach((key) => {
      promotionSectionLoadedMore[key] = _.pick(this.state.promotionSection[key as PromotionSectionType], ['loadedMore']);
    });

    // 將頁面操作記錄存至 storage
    // (1. URL。 2. active tab。 3. 各 section loaded more 狀態。)
    storageService.setItem(storageKeys.TempInfo, JSON.stringify({ url: RouterSettings.Promotions.List, activeTab: this.state.activeTab, promotionSection: promotionSectionLoadedMore }));
  }

  // /**
  //  * @description 新增 window scroll 事件監聽
  //  */
  // addWindowScrollEvent = () => {
  //   window.addEventListener('scroll', this.setTabsFixed, false);
  // }

  // /**
  //  * @description 移除 window scroll 事件監聽
  //  */
  // removeWindowScrollEvent = () => {
  //   window.removeEventListener('scroll', this.setTabsFixed, false);
  // }

  /**
   * @description 設回跳轉頁面前的位置資訊與展開頁面
   */
  handleSetTempState = () => {
    const tempInfo = JSON.parse(storageService.getItem(storageKeys.TempInfo));
    storageService.removeItem(storageKeys.TempInfo);

    if (tempInfo.url === RouterSettings.Promotions.List) {
      // 設置 active tab
      this.handleSetTabsActive(tempInfo.activeTab, false);
      // 設置各 Section 「載入更多」狀態 (State)
      Object.keys(tempInfo.promotionSection).forEach((sectionKey) => {
        this.setState(state => ({
          ...state,
          promotionSection: {
            ...state.promotionSection,
            [sectionKey]: {
              ...state.promotionSection[sectionKey as PromotionSectionType],
              loadedMore: tempInfo.promotionSection[sectionKey].loadedMore
            }
          }
        }));
      });
      // window.scrollTo(0, tempInfo.scrollY);
    } else {
      commonService.scrollToTop();
    }
  }

  // /**
  //  * @description 視窗滾動至 Tabs 區塊時，Tabs 區塊設置 Fixed (Fixed 在 Header 下方)
  //  */
  // setTabsFixed = () => {
  //   if (this.sectionPromotionRef && this.sectionPromotionRef.current) {
  //     const headerHeight = document.getElementsByTagName('header')[0].clientHeight;
  //     const tabsHeight = document.getElementsByClassName('card-grid-list__tabs')[0].clientHeight;
  //     const tabsOffsetTop = (window.pageYOffset + this.sectionPromotionRef.current.getBoundingClientRect().top) - (headerHeight + tabsHeight);
  //     const scrollTopPosition = window.pageYOffset;

  //     this.setState(state => ({ ...state, tabFixed: (scrollTopPosition > tabsOffsetTop) }));
  //   }
  // }

  /**
   * @description 設置 tab active
   */
  handleSetTabsActive = (tabType: string, applyAnimation: boolean = true) => {
    const promotionSection = this.handleUpdatePromotionSection(tabType);
    // 設置 active tab state
    this.setState(state => ({
      ...state,
      activeTab: tabType,
      promotionSection: { ...promotionSection }
    }));

    // 切換 Tab 視窗滾動至指定區塊
    const headerHeight = document.getElementsByTagName('header')[0].clientHeight;
    if (tabType !== PromotionType.All) {
      setTimeout(() => {
        const tabFixedHeight = document.getElementsByClassName('card-grid-list__tabs-fix')[0].clientHeight;
        const sectionRef = this.state.promotionSection[tabType as PromotionSectionType].ref;
        // (sectionRef && sectionRef.current) && window.scrollTo({ top: sectionRef.current.offsetTop + tabFixedHeight - (headerHeight + tabFixedHeight), behavior: applyAnimation ? 'smooth' : 'auto' });
        (sectionRef && sectionRef.current) && window.scrollTo({ top: sectionRef.current.offsetTop + tabFixedHeight - (headerHeight + tabFixedHeight) });
      });
    } else {
      // 全部(Tab)，視窗移至「活動列表」頂端
      // (this.promotionsListRef && this.promotionsListRef.current) && window.scroll({ top: this.promotionsListRef.current.offsetTop - headerHeight, behavior: applyAnimation ? 'smooth' : 'auto' });
      (this.promotionsListRef && this.promotionsListRef.current) && window.scroll({ top: this.promotionsListRef.current.offsetTop - headerHeight });
    }
  }

  /**
   * @description 處理各 Section 載入更多
   * @param sectionKey 頁面 Section 的 Key 值
   */
  handleLoadMore = (sectionKey: string) => {
    const promotionSection = this.handleUpdatePromotionSection(sectionKey);

    this.setState(state => ({
      ...state,
      promotionSection: { ...promotionSection }
    }));
  }

  /**
   * @description 取得更新展開區塊後的列表資訊
  */
  handleUpdatePromotionSection = (sectionKey: string) => {
    const promotionSection:any = { ...this.state.promotionSection };
    _.forEach(Object.keys(promotionSection), (promotionSectionKey:any) => {
      // 預設展開為 false
      promotionSection[promotionSectionKey].loadedMore = false;
      // 若為使用中的區塊，設定為 true
      if (promotionSectionKey === sectionKey) {
        promotionSection[promotionSectionKey].loadedMore = true;
      }
    });

    return promotionSection;
  }

  /**
   * @description 處理 Card 點擊後導頁
   * @param sn Data 的 SN 參數
   * @param sectionKey Promotion Section Key
   */
  handleCardGridClick = async (sn: number, sectionKey: string) => {
    let promoInfos;
    const route = this.state.promotionSection[sectionKey as PromotionSectionType].route;

    switch (sectionKey) {
      case PromotionType.Promotion:
        promoInfos = await service.fetchPromotion(sn);
        break;
      case PromotionType.PrizeWinner:
        promoInfos = await service.fetchPrizeWinnerInfo(sn);
        break;
      case PromotionType.ValueAdd:
        promoInfos = await service.fetchValueAdd(sn);
        break;
    }
    this.setState({ activeTab: sectionKey });
    if (promoInfos) {
      storageService.setItem(storageKeys.PromotionDetail, JSON.stringify(promoInfos));
      this.props.history.push({ pathname: route, state: { promotionType: sectionKey } });
    }
  }

  render () {
    // #region 優惠活動

    // 優惠活動資料 篩選只顯示尚未過期的資料 (END_DATE)
    const activities = _.cloneDeep(this.state.activities.ACTIVITY).filter((activity: Activity) => moment().isBefore(activity.END_DATE));

    // #endregion

    return (
      <div className="promotions-list">
        {/* 優惠活動 */}
        {activities.length > 0 && (
          <div className="promotions">
            <div className="template-container">
              <div className="template-content">
                <div className="promotions__title">優惠活動</div>
                <div className="promotions__slider-section">
                  <div className="promotions__slider-container">
                    <SliderAdvanced name="promotions-slider">
                      {activities.map((activity: Activity, index: number) => (
                        <SliderAdvanced.Item title={activity.TITLE} desc={activity.BRIEF} key={index} activityUrl={activity.ACTIVITY_URL}>
                          <span>
                            <img src={activity.IMAGE_NAME_PC} alt={`${activity.TITLE} ${activity.BRIEF}`} className="promotions__slider-image-pc" />
                            <img src={activity.IMAGE_NAME_MOBILE} alt={`${activity.TITLE} ${activity.BRIEF}`} className="promotions__slider-image-mobile" />
                          </span>
                        </SliderAdvanced.Item>
                      ))}
                    </SliderAdvanced>
                  </div>
                </div>
              </div>
            </div>
            <div className="promotions__background-block--main-color" />
            <div className="promotions__background-block--minor-color" />
          </div>
        )}
        {/* 活動列表 */}
        <div className="card-grid-list" ref={this.promotionsListRef}>
          <div className="card-grid-list__header">
            <div className="card-grid-list__tabs">
              <div className={'card-grid-list__tabs-fix' + (this.state.tabFixed ? ' card-grid-list__tabs-fix--fixed' : '')}>
                <div className="card-grid-list__tabs-container">
                  <div className="card-grid-list__tabs-wrap">
                    <div
                      className={'card-grid-list__tab' + (this.state.activeTab === PromotionType.All ? ' card-grid-list__tab--active' : '')}
                      onClick={() => this.handleSetTabsActive(PromotionType.All)}
                    >
                      <span>全部</span>
                    </div>
                    {Object.keys(this.state.promotionList).map((sectionKey, index: number) => (
                      <div
                        className={'card-grid-list__tab' + (this.state.activeTab === sectionKey ? ' card-grid-list__tab--active' : '')}
                        key={index}
                        onClick={() => this.handleSetTabsActive(sectionKey)}
                      >
                        <span>{PromotionTypeDefines[sectionKey as PromotionSectionType]}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card-grid-list__content">
            {Object.keys(this.state.promotionList).map((sectionKey, index: number) => {
              const sectionTitle = PromotionTypeDefines[sectionKey as PromotionSectionType];
              const sectionRef = this.state.promotionSection[sectionKey as PromotionSectionType].ref;
              const sectionLoadedMore = this.state.promotionSection[sectionKey as PromotionSectionType].loadedMore;
              const sectionInitDataAmount = this.state.promotionSection[sectionKey as PromotionSectionType].initDataAmount;
              const sectionDataFilter = _.cloneDeep(this.state.promotionList[sectionKey as PromotionSectionType]).filter((promotion: PromotionContent) => moment(moment().format('YYYYMMDD')).isSameOrBefore(moment(promotion.END_DATE)));
              const sectionDataPc = !sectionLoadedMore ? [...sectionDataFilter].splice(0, sectionInitDataAmount) : [...sectionDataFilter];
              const sectionDataMobile = [...sectionDataFilter];
              return (
                <div className="card-grid-list__section" key={index} ref={sectionRef}>
                  <div className="template-container">
                    <div className="template-content">
                      <div className="card-grid-list__section-title">{sectionTitle}</div>
                      <div className="card-grid-list__section-content">
                        <div className="card-grid-list__pc">
                          <div className="card-grid-list__pc-section-content">
                            {sectionDataPc.map((data: PromotionContent, index: number) => (
                              <CardGrid
                                key={index}
                                imgUrl={data.IMAGE_URL}
                                title={data.TITLE}
                                period={`${moment(data.START_DATE).format('YYYY/MM/DD')} ~ ${moment(data.END_DATE).format('YYYY/MM/DD')}`}
                                desc={data.BRIEF}
                                onClick={() => this.handleCardGridClick(data.SN, sectionKey)}
                              />
                            ))}
                          </div>
                          {this.state.promotionList[sectionKey as PromotionSectionType].length > sectionInitDataAmount && !sectionLoadedMore && (
                            <div className="card-grid-list__pc-section-controls">
                              <button
                                type="button"
                                className="card-grid-list__more-btn"
                                onClick={() => this.handleLoadMore(sectionKey)}
                              >
                                載入更多
                              </button>
                            </div>
                          )}
                        </div>
                        <div className="card-grid-list__mobile">
                          <div className="card-grid-list__mobile-section-content">
                            {sectionDataMobile.length > 0 && (
                              <SliderMobile
                                name={`promotions-list-${sectionKey}-slider`}
                                config={{ loop: true }}
                              >
                                {sectionDataMobile.map((data: PromotionContent, index: number) => (
                                  <SliderMobile.Item key={index}>
                                    <CardGrid
                                      imgUrl={data.IMAGE_URL}
                                      title={data.TITLE}
                                      period={`${moment(data.START_DATE).format('YYYY/MM/DD')} ~ ${moment(data.END_DATE).format('YYYY/MM/DD')}`}
                                      desc={data.BRIEF}
                                      onClick={() => this.handleCardGridClick(data.SN, sectionKey)}
                                    />
                                  </SliderMobile.Item>
                                ))}
                              </SliderMobile>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
};

export default PromotionsList;
